import ArrayFilters from './ArrayFilters';
import CurrencyFilters from './CurrencyFilters';
import DateFilters from './DateFilters';
import NumberFilters from './NumberFilters';
import StringFilters from './StringFilters';

let filters = {};
Object.assign(filters, ArrayFilters);
Object.assign(filters, CurrencyFilters);
Object.assign(filters, DateFilters);
Object.assign(filters, NumberFilters);
Object.assign(filters, StringFilters);

export default filters;



// WEBPACK FOOTER //
// ./src/filters/index.js